import React from "react";
import BookingsModule from "./bookings";
import TotalVisitsModule from "./totalVisits/index";
import AverageNumberOfVisitsPerClientModule from "./averageNumberOfVisitsPerClient/averageNumberOfVisitsPerClientNew/index";
import AverageNumberOfClientsPerClassModule from "./averageNumberOfClientsPerClass/index";
import AverageClassSizeByInstructorModule from "./averageClassSizeByInstructor/index";
import ActiveClientsModule from "./activeClients/index";
import PageWithConfigurator from "../../global/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Attendance",
  configuratorWidth: 480,
  moduleList: [
    TotalVisitsModule,
    BookingsModule,
    AverageNumberOfVisitsPerClientModule,
    AverageNumberOfClientsPerClassModule,
    AverageClassSizeByInstructorModule,
    ActiveClientsModule
  ]
};

const AttendancePage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default AttendancePage;
